/*
* Created on Jan 27, 2021
* @author: Adam Cheng <adamcheng@qnap.com>
*/
import React, {useEffect, useState} from 'react';
import ic_sys_warning_svg from '../../../static/img/utils/ic_sys_warning.svg';
import * as ReactDom from "react-dom";
import {useTranslation} from "react-i18next";
import {convert_error_code, isAsync} from "../../../service/common";

const ModalAlertComponent = ({children, isOpen, onClose, onConfirmAction, externalAlert=false}) => {
    const {t} = useTranslation();
    const [showAlert, setShowAlert] = useState(false);
    // alert-info / alert-error / alert-success / alert-warning
    const [showAlertType, setShowAlertType] = useState('info');
    const [message, setMessage] = useState('');
    const [simpleButton, setSimpleButton] = useState(false);


    const alert = (show, type, code, message, auto_hide=0) => {
        setShowAlert(show);
        setShowAlertType(type);
        if ( type === 'error') {
            setMessage(t(convert_error_code(code, message)));
        }
        else {
            setMessage(t(message));
        }
        if (auto_hide > 0) {
            window.setTimeout(()=>{
                setShowAlert(false);
            }, auto_hide);
        }
    }

    const onConfirmClick = async () => {
        if (typeof onConfirmAction.then == 'function') {
            onConfirmAction().then(data=>{
                if (!externalAlert) {
                    alert(true, 'success', 0, t('@Success@'));
                }
            }).catch(err=>{
                if (!externalAlert) {
                    alert(true, 'error', err.code, err.message);
                }
            });
        }
        else {
            try {
                await onConfirmAction(alert, setSimpleButton);
                if (!externalAlert) {
                    alert(true, 'success', 0, t('@Success@'));
                }
            }
            catch (err) {
                console.error(err);
                const code = err?.response?.data ? err.response.data.code : '';
                const message = err?.response?.data ? err.response.data.message : err.message;
                alert(true, 'error', code, message);
            }
        }
        // try {
        //     if (isAsync(onConfirmAction)) {
        //         await onConfirmAction(alert, setSimpleButton);
        //         if (!externalAlert) {
        //             alert(true, 'success', 'Success');
        //         }
        //     }
        //     else {
        //         // onSubmit();
        //         // Promise.resolve(onSubmit()).then(data=>{
        //         //     alert(true, 'success', 'Success');
        //         // }).catch(err=>{
        //         //     alert(true, 'error', err.message);
        //         // });
        //         if (typeof onConfirmAction.then == 'function') {
        //             onConfirmAction().then(data=>{
        //                 if (!externalAlert) {
        //                     alert(true, 'success', 'Success');
        //                 }
        //             }).catch(err=>{
        //                 if (!externalAlert) {
        //                     alert(true, 'error', err.message);
        //                 }
        //             });
        //         }
        //         else {
        //             onConfirmAction();
        //         }
        //     }
        // }
        // catch (err) {
        //     console.error(err);
        //     const code = err?.response?.data ? err.response.data.code : '';
        //     const message = err?.response?.data ? err.response.data.message : err.message;
        //     alert(true, 'error', `[${code}] ${message}`);
        // }
    }

    useEffect(()=>{
        if (isOpen === false) {
            return null;
        }
    });


    return ReactDom.createPortal(
        <>
            {isOpen && <div className="screen-mask visible"/> }
            {isOpen && <div className="dialog-wrapper">
                <div className="dialog dialog-alert-msg">
                    <div className="dialog-header">
                        <div className="close" onClick={()=>onClose(false)} />
                    </div>
                    <div className="dialog-body">
                        <div className={`dialog-inner-alert alert-${showAlertType} ${showAlert ? '' : 'hide'}`}>
                            <div className="alert-content">
                                <button type="button" className="alert-close-btn" aria-hidden="true" onClick={()=>setShowAlert(false)}>×</button>
                                <div className="alert-msg">
                                    {message}
                                </div>
                            </div>
                        </div>
                        <div className="alert-ic">
                            <img src={ic_sys_warning_svg} alt="" />
                        </div>
                        <div className="dialog-content">
                            {children}
                        </div>
                    </div>
                    <div className="dialog-footer clear">
                        <div className="pull-right">
                            {!simpleButton ?
                                <div className="q-btn-group">
                                    <button type="button" className="q-btn q-btn-primary"
                                            onClick={async () => onConfirmClick(alert, setSimpleButton)}>{t('@Confirm@')}</button>
                                    <button type="button" className="q-btn q-btn-default"
                                            onClick={() => onClose(false)}>{t('@Cancel@')}</button>
                                </div>
                                :
                                <div className="q-btn-group">
                                    <button type="button" className="q-btn q-btn-default"
                                            onClick={() => onClose(false)}>{t('@Close@')}</button>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>}
        </>,
        document.getElementById('modal-dialog')
    );
}

export default ModalAlertComponent;